const ENDictionary = [
    'daily',
    'rush',
    'tug',
    'stem',
    'war',
    'distinct',
    'fish',
    'meddle',
    'jail',
    'grain',
    'inexpensive',
    'lean',
    'hobbies',
    'square',
    'furniture',
    'provide',
    'stay',
    'brother',
    'advice',
    'paddle',
    'injure',
    'old',
    'unarmed',
    'hapless',
    'kitty',
    'value',
    'tight',
    'unwritten',
    'house',
    'ablaze',
    'cause',
    'quickest',
    'vegetable',
    'half',
    'teeny',
    'precede',
    'grey',
    'plant',
    'system',
    'narrow',
    'jobless',
    'chance',
    'control',
    'admit',
    'staking',
    'truculent',
    'building',
    'unpack',
    'cream',
    'remove',
    'bell',
    'lowly',
    'allow',
    'lewd',
    'possessive',
    'poke',
    'addition',
    'repulsive',
    'year',
    'unhealthy',
    'obeisant',
    'duck',
    'pear',
    'squeeze',
    'sassy',
    'club',
    'ossified',
    'recognise',
    'blue-eyed',
    'whirl',
    'encouraging',
    'spell',
    'dolls',
    'entertaining',
    'icy',
    'adjoining',
    'bent',
    'ill',
    'melted',
    'grotesque',
    'pen',
    'excite',
    'dinner',
    'hope',
    'available',
    'mighty',
    'scale',
    'children',
    'wriggle',
    'attractive',
    'frequent',
    'obtain',
    'mother',
    'type',
    'field',
    'horses',
    'color',
    'flaky',
    'pipe',
    'sniff',
]


export default ENDictionary;